import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, Select } from 'components';
import { ClientService, ProfileService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import addCurrentLocation from 'google-maps-current-location';
import { ArrowLeft, PinIcon } from 'assets/icons';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
	history?: any;
}

const STEPS = {
	DATA: 1,
	ADDRESS: 2
}

// @ts-ignore
const google = window.google;

class CreateClient extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        email: '',
	        lastname: '',
	        position: '',
	        password: '',
	        document_type_id: Constants.DOCUMENT_TYPES.V,
	        document: '',
	        tax_document: '',
	        phone: '',
	        user_type_id: Constants.USER_TYPES.COMMON,
	        state_id: '',
			city_id: '',
			municipality_id: '',
			address: '',
			indications: '',
			information: '',
			name_address: '',
			latitude: '',
			longitude: ''
		},
		document_types: [],
		step: STEPS.DATA,
		error_map: false,
		states: [],
		cities: [],
		municipalities: [],
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || '',
					email: this.props.item?.email || '',
					lastname: this.props.item?.lastname || '',
					phone: this.props.item?.phone || '',
					document: this.props.item?.document || '',
					tax_document: this.props.item?.tax_document || '',
					document_type_id: this.props.item?.document_type_id || Constants.DOCUMENT_TYPES.V,
					user_type_id: this.props.item?.user_type_id || ''
				}
			});
		}

		this.load();
	}

	load = async () => {
		const res: any = await ProfileService.get({
			user_id: this.props.item?.id || 0
		});
		this.setState({
			document_types: res.document_types,
			states: res.states
		});
	}

	submit = async (create_quote = false) => {

		if (!this.state.form.document && [Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo cédula es requerido");
			return;
		}

		if (!this.state.form.tax_document && [Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1) {
			Globals.showError("El campo RIF es requerido");
			return;
		}

		if (this.props.item != null) {
			await ClientService.admin.update({
				user_id: this.props.item?.id,
				...this.state.form,
			});
			Globals.showSuccess("Se ha modificado el cliente correctamente");
			Socket.emit(SocketEvents.UPDATE_USER,{
				user_id: this.props.item?.id
			});
			this.props.onClose();
		}
		else {
			if (create_quote) {
				const {
					state_id,
					city_id,
					municipality_id,
					address,
					information,
					name_address,
					indications
				} = this.state.form;

				if (!state_id || !city_id || !municipality_id || !address || !name_address || !indications) {
					Globals.showError("Debe ingresar todos los datos para continuar");
					return;
				}
			}

			const res: any = await ClientService.admin.create({
				...this.state.form,
			});
			Globals.showSuccess("Se ha creado el cliente correctamente");
			this.props.onClose();

			if (create_quote) {
				this.props.history.replace('/admin/quotes?create_from_user=true&user_id=' + res.user?.id);
			}
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	setStep = async (step: number) => {
		if (step == STEPS.ADDRESS) {
			if (!this.state.form.document && [Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1) {
				Globals.showError("El campo cédula es requerido");
				return;
			}

			if (!this.state.form.tax_document && [Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1) {
				Globals.showError("El campo RIF es requerido");
				return;
			}

			await ClientService.admin.validateCreate({
				...this.state.form,
			});
		}

		this.setState({
			step
		},() => {
			this.setMap();
		});
	}

	getCities = async () => {
		const res: any = await ProfileService.getCities({
			state_id: this.state.form.state_id
		});
		this.setState({
			cities: res.cities,
			municipalities: res.municipalities
		});
	}

	setMap = async () => {
		const map = new google.maps.Map(document.getElementById('map'), {
	      zoom: 13,
	      center: new google.maps.LatLng(this.state.form?.latitude || '10.48801',this.state.form?.longitude || '-66.87919'),
	      draggable: true,
	      zoomControl: true,
	      streetViewControl: false,
	      fullscreenControl: false,
	      scaleControl: false,
	      rotateControl: false
	    });

	    addCurrentLocation(map,{
		  markerStyle: {
			scale: 0
		  },
		  showAccuracyRadius: false
		});

	    const marker = new google.maps.Marker({
	      position: new google.maps.LatLng(this.state.form?.latitude || '10.48801',this.state.form?.longitude || '-66.87919'),
	      map,
	      title: 'Ubicación',
	      animation: google.maps.Animation.DROP,
	      draggable: true,
	      icon: PinIcon
	    })

	    await this.setState({
			map,
			marker
	    });

	    google.maps.event.addListener(marker,'dragend',(event: any) => {
	    	this.setState({
	    		form: {
	    			...this.state.form,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});
	    });

	    google.maps.event.addListener(map,'click',(event: any) => {
	    	this.setState({
	    		form: {
	    			...this.state.form,
	    			latitude: event.latLng.lat(),
	    			longitude: event.latLng.lng()
	    		}
	    	});

	    	// @ts-ignore
	    	this.state.marker?.setPosition(new google.maps.LatLng(event.latLng.lat(),event.latLng.lng()));
	    });

	    const input = document.getElementById('location-input');
        const autocomplete = new google.maps.places.Autocomplete(input, {
        	componentRestrictions: {
        		country: "ve"
        	}
        });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            var place = autocomplete.getPlace();
            const latitude = place.geometry.location.lat();
            const longitude = place.geometry.location.lng();
            this.setState({
            	form: {
            		...this.state.form,
            		latitude,
            		longitude
            	}
            });
            // @ts-ignore
            document.querySelector('#location-input').value = '';
            map.setCenter(new google.maps.LatLng(latitude,longitude));
            marker.setPosition(new google.maps.LatLng(latitude,longitude));
        });
	}
	
	render() {
		const { error_map } = this.state;

		return (
			<div id="create-moderator">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<div className="container-scroll-modal-right">
					{
						this.state.step == STEPS.DATA && (
							<React.Fragment>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.name }
										name="name" 
										placeholder="Nombre"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.lastname }
										name="lastname" 
										placeholder="Apellido"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.email }
										name="email" 
										placeholder="Correo"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									<Select
										placeholder="Tipo de Documento"
										name="document_type_id"
										onChange={ (e: any) => {
											this.setState({
												form: {
													...this.state.form,
													document_type_id: parseInt(e.target.value)
												}
											});
										} }
										value={ this.state.form.document_type_id }
										options={ this.state.document_types.map((i: any) => {
											return {
												value: i.id,
												label: i.name
											}
										}) } />
								</div>
								{
									[Constants.DOCUMENT_TYPES.V, Constants.DOCUMENT_TYPES.E].indexOf(this.state.form.document_type_id) != -1 && (
										<div className="col-md-12">
											<Input
												color="white"
												value={ this.state.form.document }
												name="document" 
												placeholder="Cédula"
												onChange={ this.change } />
										</div>
									)
								}
								{
									[Constants.DOCUMENT_TYPES.J, Constants.DOCUMENT_TYPES.G].indexOf(this.state.form.document_type_id) != -1 && (
										<div className="col-md-12">
											<Input
												color="white"
												value={ this.state.form.tax_document }
												name="tax_document" 
												placeholder="RIF"
												onChange={ this.change } />
										</div>
									)
								}
								<div className="col-md-12">
									<Select
										placeholder="Tipo de Usuario"
										name="user_type_id"
										onChange={ (e: any) => this.change(e) }
										value={ this.state.form.user_type_id }
										options={ [
											{ value: Constants.USER_TYPES.COMMON.toString(), label: 'Común' },
											{ value: Constants.USER_TYPES.CORPORATE.toString(), label: 'Corporativo' },
											{ value: Constants.USER_TYPES.SUBUSER.toString(), label: 'Sub-Usuario' }
										] } />
								</div>
								<div className="col-md-12">
									<Input
										type="number"
										color="white"
										value={ this.state.form.phone }
										name="phone" 
										maxLength={ 11 }
										placeholder="Teléfono"
										onChange={ this.change } />
								</div>
								{
									this.props.item != null && (
										<div className="col-md-12">
											<Input
												type="password"
												color="white"
												value={ this.state.form.password }
												name="password" 
												placeholder={ this.props.item != null ? "Cambiar Contraseña (Opcional)" : "Contraseña" }
												onChange={ this.change } />
										</div>
									)
								}
								{
									this.props.item != null ? (
										<div className="text-center">
											<Button type="button" className="btn-blue" onClick={ () => this.submit(false) }>
												Guardar
											</Button>
										</div>
									) : (
										<div className="text-center">
											<Button type="button" className="btn-blue" onClick={ () => this.setStep(STEPS.ADDRESS) }>
												Continuar
											</Button>
										</div>
									)
								}
							</React.Fragment>
						)
					}
					
					{
						this.state.step == STEPS.ADDRESS && (
							<React.Fragment>
								<div className="col-md-12">
									<div className="row-title" onClick={ () => this.setStep(STEPS.DATA) }>
										<img src={ ArrowLeft } className="arrow-left-green" />
										<h3 className="title-green">Volver</h3>
									</div>
								</div>
								<div className="col-md-12">
									<Select
										label="Estado"
										name="state_id"
										onChange={ (e: any) => this.change(e,() => {
											this.setState({
												form: {
													...this.state.form,
													city_id: '',
													municipality_id: ''
												}
											},() => this.getCities());
										}) }
										value={ this.state.form.state_id }
										options={ this.state.states.map((i: any) => {
											return {
												value: i.id,
												label: i.name
											}
										}) } />
								</div>
								<div className="col-md-12">
									<Select
										label="Ciudad"
										disabled={ !this.state.form.state_id }
										name="city_id"
										onChange={ this.change }
										value={ this.state.form.city_id }
										options={ this.state.cities.map((i: any) => {
											return {
												value: i.id,
												label: i.name
											}
										}) } />
								</div>
								<div className="col-md-12">
									<Select
										label="Municipio"
										disabled={ !this.state.form.state_id }
										name="municipality_id"
										onChange={ this.change }
										value={ this.state.form.municipality_id }
										options={ this.state.municipalities.map((i: any) => {
											return {
												value: i.id,
												label: i.name
											}
										}) } />
								</div>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.address }
										name="address" 
										label="Dirección"
										placeholder="Indique la dirección completa"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.indications }
										name="indications" 
										label="Indicaciones de la dirección"
										placeholder="Escribe aquí instrucciones o comentarios"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.information }
										name="information" 
										label="Información adicional"
										placeholder="Ej: Piso/Oficina/Apto"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									<Input
										color="white"
										value={ this.state.form.name_address }
										name="name_address" 
										label="Nombre de la dirección"
										placeholder="Nombre/Indicador de la dirección"
										onChange={ this.change } />
								</div>
								<div className="col-md-12">
									{
										!error_map && (
											<React.Fragment>
												<label className="location-input-label">Indicar punto en el mapa</label>
												<input type="text" placeholder="Buscar dirección Google Mapas" id="location-input" />
											</React.Fragment>
										)
									}

									{
										!error_map && (
											<div id="map"></div>
										)
									}

									{
										error_map && (
											<div className="location-permission">
												<p>Para el correcto funcionamiento de la página debe permitir el acceso a su ubicación</p>
											</div>
										)
									}
								</div>
								<div className="row col-md-12 row-buttons">
									<div className="col-md-6 text-center">
										<Button type="button" className="btn-transparent" onClick={ () => this.submit(false) }>
											Finalizar
										</Button>
									</div>
									<div className="col-md-6 text-center">
										<Button type="button" className="btn-blue" onClick={ () => this.submit(true) }>
											Crear una cita
										</Button>
									</div>
								</div>
							</React.Fragment>
						)
					}
				</div>
			</div>
		)
	}
}

export default CreateClient;